import React, {useEffect, useState, useContext} from 'react';

import {
    AppBar,
    Box,
    Button,
    CssBaseline, Dialog, DialogActions, DialogContent, DialogTitle,
    FormControlLabel, Grid,
    IconButton,
    Switch,
    Toolbar, Tooltip,
    Typography
} from "@mui/material";

import {Link, redirect, useLocation, useSearchParams} from "react-router-dom";
import DehazeIcon from '@mui/icons-material/Dehaze';
import {useDispatch, useSelector} from "react-redux";


import logoImg from '../../../imgs/icon2.png';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useMsal} from "@azure/msal-react";
import CloseIcon from "@mui/icons-material/Close";

import { Twirl as Hamburger } from 'hamburger-react'
import {configs, domainAlias, getDomainAlias} from "../../../constants";
import EnvStateData, {toggleEnv} from "../../../core/reducers/environmentStateSlice";
import api from "../../../core/api/base-api";



export default function Header({handleDrawerOpen, open}) {
    const { instance } = useMsal();

    let activeAccount;

    if (instance) {
        activeAccount = instance.getActiveAccount();
    }

    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const sessionState = useSelector((state) => state.data.SourceMode);
    const userSession = useSelector((state) => state.data.UserSession);

    const gameConfig = configs[getDomainAlias()]

    const [showTypesModal, setShowTypesModal] = useState(false);

    const location = useLocation()
    const queryParams = new URLSearchParams(location.search);
    //
    // const {data: userInfo, isLoading, isError, error} = useGetUserQuery({}, {
    //
    // })
    const userInfo = {displayName:userSession?.user?.name}



    const loginContent = () => {
        if(userSession.authenticated) {
            // return (
            //     <Button color="warning" variant="outlined" >Logout</Button>
            // )
        } else {
            return (
                <Button color="warning" variant={"contained"} >Login</Button>
            );
        }

        // case AuthenticationState.InProgress:
        //     return (<p>Authenticating...<Link onClick={authProvider.login}>login</Link></p>);
        // default:
        //     return (<Link onClick={authProvider.login}>login</Link>)

    }


    const handleLoginPopup = () => {
        /**
         * When using popup and silent APIs, we recommend setting the redirectUri to a blank page or a page
         * that does not implement MSAL. Keep in mind that all redirect routes must be registered with the application
         * For more information, please follow this link: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/login-user.md#redirecturi-considerations
         */
        instance
            .loginPopup({
                ...{},
                redirectUri: '/dummy.html',
            })
            // .then((data) => {
            //     console.log("AUTH DONE")
            //     console.log(data)
            //     dispatch({
            //         type: 'AUTH_SELF_SUCCESS', payload: {
            //             data: data.account.idTokenClaims.roles
            //         }
            //     });
            //     localStorage.setItem("azureToken", data.idToken)
            // })
            .catch((error) => console.log(error));
    };

    const handleLoginRedirect = () => {
        instance.loginRedirect({}).catch((error) => console.log(error));
    };

    const handleLogoutPopup = () => {
        instance
            .logoutPopup({
                mainWindowRedirectUri: '/', // redirects the top level app after logout
                account: instance.getActiveAccount(),
            })
            .then(() => {

            })
            .catch((error) => {
                console.log("LOGOUT")
                console.log(error)
            });
    };

    //const isProd = localStorage.getItem("isProd")==='true' //gameConfig.code.indexOf('stage')>=0
    const envStateData = useSelector(state => state.data.EnvStateData); // Для отображения текущего статуса
    const isProd = envStateData.isProd

    const allDebug = useSelector(state => state.data); // Для отображения текущего статуса
console.log('all State Debug')
console.log(allDebug)

    const switchEnv = () => {
        dispatch(toggleEnv());
        dispatch(api.util.resetApiState());
    }

    return (
        <Box className="header" sx={{flexGrow: 1}} pb={3}>
            <AppBar position="static" color="default" className={isProd ? "prod-mode-header" : ""}>
                <Toolbar >

                    <Box sx={{height: '100%', display: 'flex', alignItems: 'center', paddingRight: '10px'}}>
                        <Link to="/">
                            <img src={logoImg} alt="Push Notifications" height="30px"
                                 sx={{maxWidth: '100%', paddingRight: '20px'}}/>
                        </Link>
                    </Box>
                    <Typography color="inherit" component="div">
                        <div className={"menu-title"}>

                            Push Notifications
                            <span style={{opacity:0.5}}>&nbsp;{gameConfig.title}&nbsp;</span>
                            <span style={{opacity:0.5,color:isProd?'#92278f':'#000'}}>{isProd?'PROD':'stage'}</span>
                        </div>
                    </Typography>

                    <Box sx={{flexGrow: 1}}/>
                    <Grid item sm={4} display={'flex'} justifyContent={'end'}>
                        <Box>
                            <FormControlLabel sx={{ml: 1}}
                                              onClick={switchEnv}
                                              control={<Switch color={"warning"} checked={isProd}/>}
                                              label={isProd ? "Prod" : "Dev"}/>
                        </Box>
                    </Grid>


                    <Grid item sm={1} display={'flex'} justifyContent={'end'}>
                        <Box sx={{display: {md: 'flex'}, ml: 1}}>
                            <AuthenticatedTemplate>

                                <Button variant={"outlined"} color="warning" onClick={handleLogoutPopup}>
                                    Logout
                                </Button>
                            </AuthenticatedTemplate>
                            <UnauthenticatedTemplate>
                                <Button variant={"outlined"} color="warning" onClick={handleLoginPopup}>
                                    Sign in
                                </Button>
                            </UnauthenticatedTemplate>
                        </Box>
                    </Grid>
                </Toolbar>
            </AppBar>

        </Box>


    );
}


